import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Progress } from "../components/ui/progress";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClientProgress() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClient();
  }, [id]);

  const fetchClient = async () => {
    try {
      const res = await axios.get(`${API}/clients/${id}`);
      setClient(res.data);
    } catch (err) {
      toast.error("Failed to load client");
    } finally {
      setLoading(false);
    }
  };

  const getScoreChange = (starting, current) => {
    if (!starting || !current) return null;
    return current - starting;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  if (!client) {
    return <div className="text-center py-12 text-zinc-400">Client not found</div>;
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{client.name}'s Progress</h1>

      <div className="grid md:grid-cols-3 gap-6">
        {['equifax', 'experian', 'transunion'].map((bureau) => {
          const starting = client[`starting_score_${bureau}`];
          const current = client[`current_score_${bureau}`] || client[`score_${bureau}`];
          const change = getScoreChange(starting, current);
          
          return (
            <Card key={bureau} className="bg-zinc-900 border-zinc-800">
              <CardHeader>
                <CardTitle className="capitalize">{bureau}</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="text-center">
                    <p className="text-5xl font-bold">{current || '-'}</p>
                    {change !== null && (
                      <div className={`flex items-center justify-center gap-1 mt-2 ${
                        change > 0 ? 'text-green-400' : change < 0 ? 'text-red-400' : 'text-zinc-400'
                      }`}>
                        {change > 0 ? <TrendingUp className="h-4 w-4" /> : 
                         change < 0 ? <TrendingDown className="h-4 w-4" /> : 
                         <Minus className="h-4 w-4" />}
                        <span>{change > 0 ? '+' : ''}{change} points</span>
                      </div>
                    )}
                  </div>
                  <div className="text-sm text-zinc-400">
                    <p>Starting: {starting || 'N/A'}</p>
                    <p>Current: {current || 'N/A'}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
